import { useCallback, useEffect, useState } from "react";
import {
  DesignTokens,
  Row,
  Col,
  Button,
  UndoIcon,
  RangePicker,
} from "melco-ui";

import { useTranslation } from "react-i18next";
import { isEmpty, some } from "lodash-es";
import { Search } from "../search/Search";
import { EmailHistoryListFiltersType } from "../../hooks/emailhistory/EmailHistoryListFiltersType";
import { EmailHistoryProductCodeFilter } from "./filters/EmailHistoryProductCodeFilter";
import dayjs from "dayjs";
import styled from "styled-components";

const { spacings } = DesignTokens;

type EmailHistoryListFilterProps = {
  onFiltersChange: (filters: EmailHistoryListFiltersType | undefined) => void;
};

export const EmailHistoryListFilter: React.FC<EmailHistoryListFilterProps> = ({
  onFiltersChange,
}) => {
  const { t } = useTranslation();

  const [emailHistoryFilter, setEmailHistoryFilter] = useState<
    EmailHistoryListFiltersType | undefined
  >(undefined);

  const [searchValue, setSearchValue] = useState("");
  const [emailAddressvalue, setEmailAddressValue] = useState("");

  useEffect(() => {
    console.log({ emailHistoryFilter });
    onFiltersChange(emailHistoryFilter);
  }, [emailHistoryFilter, onFiltersChange]);

  const resetFilter = useCallback(() => {
    setSearchValue("");
    setEmailAddressValue("");
    setEmailHistoryFilter(undefined);
  }, []);

  const BoxWrapper = styled.div`
    max-width: 300px;
    min-width: 225px;
  `;

  return (
    <div>
      <Row gutter={[spacings.middle, spacings.middle]}>
        <Col>
          <Search
            onSearchInputChange={(value) => {
              setEmailHistoryFilter((prevFilter) => {
                return { ...prevFilter, searchText: value };
              });
            }}
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
          />
        </Col>
        <Col>
          <Search
            onSearchInputChange={(value) => {
              setEmailHistoryFilter((prevFilter) => {
                return { ...prevFilter, emailAddress: value };
              });
            }}
            onChange={(e) => setEmailAddressValue(e.target.value)}
            value={emailAddressvalue}
            placeholder={t("emailhistory.filter.emailaddress.placeholder")}
          />
        </Col>
        <Col>
          <EmailHistoryProductCodeFilter
            onChange={(value) => {
              setEmailHistoryFilter((prevFilter) => {
                return {
                  ...prevFilter,
                  productCode: !isEmpty(value) ? value : undefined,
                };
              });
            }}
            value={emailHistoryFilter?.productCode ?? undefined}
          />
        </Col>
        <Col>
          <BoxWrapper>
            <RangePicker
              format="L"
              onChange={(value) => {
                const startTimeStamp =
                  (value && value[0] && value[0].startOf("day").toDate()) ??
                  undefined;
                const endTimeStamp =
                  (value && value[1] && value[1].endOf("day").toDate()) ??
                  undefined;

                setEmailHistoryFilter((prevFilter) => {
                  return {
                    ...prevFilter,
                    startTimeStamp,
                    endTimeStamp,
                  };
                });
              }}
              value={
                emailHistoryFilter?.startTimeStamp &&
                emailHistoryFilter?.endTimeStamp && [
                  dayjs(emailHistoryFilter?.startTimeStamp),
                  dayjs(emailHistoryFilter?.endTimeStamp),
                ]
              }
              placeholder={[
                t("emailhistory.filter.start_timestamp.placeholder"),
                t("emailhistory.filter.end_timestamp.placeholder"),
              ]}
            />
          </BoxWrapper>
        </Col>

        <Col>
          {some(emailHistoryFilter) && (
            <Button
              icon={<UndoIcon />}
              type="primary"
              onClick={resetFilter}
              data-cy-id="emailhistory-filter-reset"
              style={{ minWidth: "100%" }}
            >
              {t("filter.reset.button", { ns: "melco-common" })}
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};
